// Select padrão. Unifica o `Select` de AdminUsuarios.js/GerenciarMatriculas.js.
//
// Diferença deliberada em relação ao original: os dois tinham `appearance-none`
// sem nenhum indicador visual de seta — o usuário não tinha como notar que era um
// dropdown. Adicionamos o ícone de seta (mesmo padrão que Grade.js já usava no
// próprio `SelectWithIcon`) como correção, não como mudança de comportamento.
import React from 'react';
import { ChevronDown } from 'lucide-react';

export default function Select({
  label,
  name,
  value,
  onChange,
  options,
  icon: Icon,
  size = 'md',
  className = '',
}) {
  const height = size === 'lg' ? 'h-11' : size === 'sm' ? 'h-8' : size === 'xs' ? 'h-6' : 'h-10';
  const textSize = size === 'xs' ? 'text-[11px]' : size === 'sm' ? 'text-xs' : 'text-sm';
  const paddingLeft = Icon
    ? size === 'xs'
      ? 'pl-6'
      : size === 'sm'
        ? 'pl-7'
        : 'pl-9'
    : size === 'xs'
      ? 'pl-2'
      : size === 'sm'
        ? 'pl-2.5'
        : 'pl-3';
  const paddingRight = size === 'xs' ? 'pr-5' : 'pr-7';
  const labelSize = size === 'xs' ? 'text-[10px]' : 'text-xs';
  const spacing = size === 'xs' ? 'space-y-0.5' : 'space-y-1.5';
  const iconSize = size === 'xs' ? 'w-3 h-3' : 'w-3.5 h-3.5';
  const chevronSize = size === 'xs' ? 'w-3 h-3 right-1.5' : 'w-3.5 h-3.5 right-2';

  return (
    <div className={`${spacing} ${className}`}>
      {label && (
        <label className={`block ${labelSize} font-medium text-gray-500 dark:text-gray-400`}>
          {label}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <Icon
            className={`text-gray-400 absolute left-2.5 top-1/2 -translate-y-1/2 ${size === 'md' || size === 'lg' ? 'w-4 h-4' : iconSize}`}
          />
        )}
        <select
          name={name}
          value={value}
          onChange={onChange}
          className={`w-full ${height} ${paddingLeft} ${paddingRight} rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 ${textSize} text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all appearance-none`}
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <ChevronDown
          className={`text-gray-400 absolute top-1/2 -translate-y-1/2 pointer-events-none ${chevronSize}`}
        />
      </div>
    </div>
  );
}
